module.exports = {"340321100":"榴城镇","340321101":"包集镇","340321102":"龙亢镇","340321103":"河溜镇","340321104":"常坟镇","340321106":"双桥集镇","340321107":"魏庄镇","340321108":"万福镇","340321109":"唐集镇","340321110":"白莲坡镇","340321111":"褚集镇","340321112":"古城镇","340321113":"荆山镇","340321200":"淝南乡","340321201":"淝河乡","340321203":"陈集乡","340321205":"徐圩乡","340321206":"兰桥乡","340321400":"龙亢农场","340321401":"经济开发区","340321403":"安徽怀远龙亢经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340321.json
// module id = 976
// module chunks = 0